import React from 'react';
import T from 'prop-types';
import { Button } from 'antd';

import { STUDIO_URL } from '../../constants/app';
import { PAYMENT_SUCCESS } from '../../constants/params';

import { useBeanieCtx } from '../../ctx/beanieProvider';

const BeanieButton = ({ children, plan, size, uuid }) => {
  const { beanie, configId } = useBeanieCtx();

  if (!beanie) {
    return (
      <Button block disabled size={size} type="primary">
        {children}
      </Button>
    );
  }

  const handleOnClick = () => {
    beanie
      .redirectToBeanie({
        // stripe configuration
        items: [
          {
            plan,
            quantity: 1,
          },
        ],
        clientReferenceId: uuid,
        successUrl: `${STUDIO_URL}/settings/billing?${PAYMENT_SUCCESS}=true`,
        cancelUrl: STUDIO_URL,
        // beanie configuration
        configurationId: configId,
      })
      .then(() => {
        // if (result.error) {
        //   // If `redirectToCheckout` fails due to a browser or network
        //   // error, display the localized error message to your customer.
        // }
      });
  };

  return (
    <Button block onClick={handleOnClick} size={size} type="primary">
      {children}
    </Button>
  );
};

BeanieButton.propTypes = {
  children: T.node.isRequired,
  plan: T.string.isRequired,
  uuid: T.string.isRequired,

  size: T.string,
};

BeanieButton.defaultProps = {
  size: 'large',
};

export default BeanieButton;
